import { useMemo } from 'react'

import { useNavigate } from 'react-router-dom'

import clsx from 'clsx'

import { RoutingPaths } from 'app/routes/routes'

import { getKyrgyzstanGalleryRouteState } from 'entities/kyrgyzstan/lib'

import { RealtyImage } from 'shared/api/kyrgyzstan/search'
import GhostImage from 'shared/images/ghost.png'
import { Carousel } from 'shared/ui/carousel'
import { Paper } from 'shared/ui/paper'

import s from './styles.module.scss'

interface ImageSectionProps {
  id: string
  name: string
  images: RealtyImage[]
}

export const ImageSection = ({ name, images, id }: ImageSectionProps) => {
  const navigate = useNavigate()

  const handleOpenGallery = () => {
    navigate(RoutingPaths.kyrgyzstan.optionDetailGallery.path(id), {
      state: getKyrgyzstanGalleryRouteState({
        id,
        title: name,
        images,
      }),
    })
  }

  const preparedImages = useMemo(
    () =>
      images.map((image) => ({
        id: image.id,
        image: image.image_url,
        image_fullpath: image.image_url,
      })),
    [images],
  )

  return (
    <div
      onClick={handleOpenGallery}
      className={s.container}
    >
      <Carousel
        dotsVariant="custom"
        images={preparedImages}
        errorImage={GhostImage}
        showCounter
        size="aspect"
      />

      <Paper
        padding={[16, 14, 12]}
        radius="0 0 16px 16px"
        className={s.content}
      >
        <h1 className={clsx('extra-bold-16', s.title)}>{name}</h1>
      </Paper>
    </div>
  )
}
